import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Container, Row, Col, Spinner, Badge, Label, Card, CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import moment from 'moment'
import qs from 'qs'
import { currencyFormatter, mon2num } from '../../../../utils/currencyFormatter'
import Breadcrumbs from '../../../../components/Common/Breadcrumb'
import { getLegalEntities, getContract } from '../../../../store/ducks/comercial'
import { getRevenueTypes } from '../../../../store/ducks/types'
import { history } from '../../../../store'
import oikosApi from '../../../../services/oikos'
import AddFiles from '../../../../components/Template/Files/AddFiles'
import AddContract2 from '../../../../components/Modal/AddContract2'
import { notifyError, notifySuccess } from '../../../../utils/notify'


class Contract extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isFilesModalOpen: false,
      isUploading: false,
      arquivoData: {},
      deleteIsLoading: false,
      deleteModalOpen: false,
      isCreatingAditivoNegociacao: false,
    }
  }

  componentDidMount() {
    if (this.props.match?.params?.id) {
      const { getLegalEntities, getContract, getRevenueTypes } = this.props


      getRevenueTypes()
      getLegalEntities()
      getContract(this.props.match.params.id)
      //getContract(5)

      return null
    }
  }

  filesRef = React.createRef();

  deleteDocuments = async (docId) => {
    this.setState({ deleteIsLoading: true });
    try {
      const deleteDoc = {
        action: 'delete',
        table: 'documento',
        data: {
          documento_id: Number(docId),
        },
      }
      console.log('deleteDoc ', deleteDoc)
      const productDeleted = await oikosApi.post('/', deleteDoc)
      notifySuccess('Documento removido com sucesso.')
      getContract(this.props.match.params.id)
    } catch (e) {
      notifyError('Erro ao remover o documento');
      console.log('Não foi possível remover o documento.', e)
    }
    this.setState({ deleteIsLoading: false, deleteModalOpen: false })
  };

  handleSubmitFiles = async () => {
    const files = this.filesRef?.current?.state?.files
    const { getContract } = this.props

    this.setState({ isUploading: true })

    if (files.length > 0) {
      await Promise.all(files.map(async file => {
        // Cria um registro na tabela de documentos para cada arquivo
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: file.props?.documentType?.tpDocumento_id,
            documento_desc: file.props?.description,
            documento_iniVig: undefined,
            documento_fimVig: undefined,
            documento_dtEmissao: undefined,
            documento_prazo: undefined,
            documento_ref: undefined,
            privacidade_id: 2,
          },
        }
        const documentCreated = await oikosApi.post('/', documentBody)

        // Cria uma vinculação entre o documento (anexo) e o contrato
        if (documentCreated.data[0].documento_id && this.props.match.params.id) {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: 'contrato',
              documentoVinc_tabId: this.props.match.params.id,
            },
          }
          await oikosApi.post('/', vinculationBody)
        }

        // Faz upload do arquivo e registra na tabela 'arquivo'
        const formData = new FormData()
        formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', file.data.path)
        const fileUploadRes = await oikosApi.post('/', formData)
        console.tron.log('fileUploadRes', fileUploadRes)
      }))
    }

    console.log('arquivos enviados com sucesso. Carregando novamente...')

    this.setState({ isFilesModalOpen: false })
    this.setState({ isUploading: false })

    getContract(this.props.match.params.id)

    /*
    */
  }


  formatContractStatus = status => {
    switch (status) {
      case 'Em andamento':
        return <Badge className="badge-soft-info mr-1">{status}</Badge>
      case 'Em conclusão':
        return <Badge className="badge-soft-warning mr-1">{status}</Badge>
      case 'Concluído':
        return <Badge className="badge-soft-success mr-1">{status}</Badge>
      case 'Cancelado':
        return <Badge className="badge-soft-danger mr-1">{status}</Badge>
      case 'Suspenso':
        return <Badge className="badge-soft-danger mr-1">{status}</Badge>
      default:
        return <Badge className="badge-soft mr-1">{status}</Badge>
    }
  }

  handleSolicitarOrcamentoAditivo = async () => {
    const contractId = Number(this.props.match?.params?.id) || 0
    const contractPropId = Number(this.props.comercial?.contract?.prop_id) || 0
    const userId = Number(this.props?.auth?.user?.pf_id) || 0

    if (!contractId) {
      notifyError('Não foi possível identificar o contrato.')
      return
    }

    if (!contractPropId) {
      notifyError('Este contrato não possui proposta de origem vinculada.')
      return
    }

    this.setState({ isCreatingAditivoNegociacao: true })

    try {
      const propRes = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'prop',
        data: {
          prop_id: contractPropId,
          prop_ativo: 1,
        },
      })}`)

      const sourceProp = Array.isArray(propRes?.data) ? propRes.data[0] : null
      const sourceNegociacaoId = Number(sourceProp?.negociacao_id) || 0

      if (!sourceNegociacaoId) {
        throw new Error('Não foi possível identificar a negociação de origem deste contrato.')
      }

      const negociacaoRes = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'negociacao',
        data: {
          negociacao_id: sourceNegociacaoId,
          negociacao_ativo: 1,
        },
      })}`)

      const sourceNegociacao = Array.isArray(negociacaoRes?.data) ? negociacaoRes.data[0] : null

      if (!sourceNegociacao) {
        throw new Error('Negociação de origem não encontrada.')
      }

      const sourceNome = String(sourceNegociacao.negociacao_nome || '').trim()
      const novaNegociacaoNome = sourceNome
        ? `${sourceNome} - Aditivo`
        : `Aditivo da negociação ${sourceNegociacaoId}`

      const createdNegociacao = await oikosApi.post('/', {
        action: 'insert',
        table: 'negociacao',
        data: {
          negociacao_nome: novaNegociacaoNome,
          negociacao_usuarioCria: userId || undefined,
          negociacao_usuarioMod: userId || undefined,
          pj_id: sourceNegociacao.pj_id || undefined,
          servico_id: sourceNegociacao.servico_id || undefined,
          negociacao_ativo: 1,
          negociacaoStatus_id: sourceNegociacao.negociacaoStatus_id || 1,
          negociacao_privada: sourceNegociacao.negociacao_privada ?? 1,
          bitrix_id: sourceNegociacao.bitrix_id || undefined,
          negociacao_obj: sourceNegociacao.negociacao_obj || undefined,
          negociacao_codTrib: sourceNegociacao.negociacao_codTrib || undefined,
          negociacao_prazo: sourceNegociacao.negociacao_prazo || undefined,
          oport_origem: sourceNegociacao.oport_origem || undefined,
          negociacao_original: sourceNegociacaoId,
        },
      })

      const novaNegociacaoId = Number(
        createdNegociacao?.data?.[0]?.negociacao_id ??
        createdNegociacao?.data?.negociacao_id
      ) || 0

      if (!novaNegociacaoId) {
        throw new Error('A negociação aditiva foi criada, mas o identificador não foi retornado.')
      }

      notifySuccess(`Solicitação de orçamento aditivo criada com sucesso. Negociação #${novaNegociacaoId}.`)
    } catch (error) {
      console.error('Erro ao solicitar orçamento aditivo', error)
      notifyError(error?.message || 'Não foi possível solicitar o orçamento aditivo.')
    } finally {
      this.setState({ isCreatingAditivoNegociacao: false })
    }
  }

  render() {
    const {
      contract, getContractIsLoading,
      legalEntities, getLegalEntitiesIsLoading,
    } = this.props.comercial

    const {
      revenueTypes, getRevenueTypesIsLoading,
    } = this.props.types

    if (getContractIsLoading || getLegalEntitiesIsLoading || getRevenueTypesIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }

    if (contract && legalEntities && revenueTypes) {
      const contractData = {
        ...contract,
        contrato_contratante: legalEntities.find(i => i.pj_id === contract.contrato_contratante),
        contrato_contratada: legalEntities.find(i => i.pj_id === contract.contrato_contratada),
      }

      const isOriginal = contractData.contratoInst_id === 1;
      const isAditamento = contractData.contratoInst_id === 2;
      const isApostilamento = contractData.contratoInst_id === 3;
      const isRescisao = contractData.contratoInst_id === 5 || String(contractData.contratoInst_desc).toLowerCase().trim() === 'rescisão' || String(contractData.contratoInst_desc).toLowerCase().trim() === 'rescisao';

      const isAditivoMode = !isOriginal;
      const hideCronograma = isRescisao || isApostilamento;
      const hideAditivos = !isOriginal;

      const formatDateOrDash = (value) => (
        value && moment(value).isValid() ? moment(value).format('DD/MM/YYYY') : '-'
      );

      let valorConsolidado = Number(contractData.contrato_vlrGlobal) || 0;
      let fimVigenciaOriginal = contractData.contrato_prazoVigencia;
      let vigenciaAtual = fimVigenciaOriginal;

      let prazoExecucaoAtual = contractData.contrato_prazoExecucao;

      if (contractData.addendums && contractData.addendums.length > 0) {
        contractData.addendums.forEach(a => {
          valorConsolidado += (Number(a.contrato_vlrGlobal) || 0);
          if (a.contrato_prazoVigencia) {
            const vigAtualTs = vigenciaAtual ? new Date(vigenciaAtual).getTime() : 0;
            const vigAddTs = new Date(a.contrato_prazoVigencia).getTime();
            if (vigAddTs > vigAtualTs) vigenciaAtual = a.contrato_prazoVigencia;
          }
          if (a.contrato_prazoExecucao) {
            const execAtualTs = prazoExecucaoAtual ? new Date(prazoExecucaoAtual).getTime() : 0;
            const execAddTs = new Date(a.contrato_prazoExecucao).getTime();
            if (execAddTs > execAtualTs) prazoExecucaoAtual = a.contrato_prazoExecucao;
          }
        });
      }

      return (
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Contrato"
              breadcrumbItems={[]}
            />

            <Tabs>
              <TabList>
                <Tab>Geral</Tab>
                {!hideCronograma && <Tab>Produtos</Tab>}
                {!hideCronograma && <Tab>Eventos de Pagamento</Tab>}
                {!hideAditivos && <Tab>Aditivos</Tab>}
                <Tab>Anexos</Tab>
              </TabList>

              <TabPanel>
                {
                  contract.proj_id &&
                  <div style={{ marginBottom: "10px" }}                >
                    <a
                      href={`https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${contract.proj_id}`}
                      target='_blank'
                    >
                      Link para a página do Projeto
                    </a>
                  </div>
                }
                <Card>
                  <CardBody>
                    <Row>
                      <Col md={12}>
                        <Label>{isApostilamento ? 'Objeto do apostilamento' : isAditamento ? 'Objeto do aditamento' : 'Objeto'}</Label>
                        <p style={{ fontWeight: 'bold' }}>{contractData.contrato_obj}</p>
                      </Col>

                      <Col md={3}>
                        <Label className="mt-4">Número</Label>
                        <p style={{ fontWeight: 'bold' }}>{contractData.contrato_num}</p>
                      </Col>

                      <Col md={3}>
                        <Label className="mt-4">Contratante</Label>
                        <p style={{ fontWeight: 'bold' }}>{contractData.contrato_contratante?.pj_nomefanta}</p>
                      </Col>

                      <Col md={3}>
                        <Label className="mt-4">Contratada</Label>
                        <p style={{ fontWeight: 'bold' }}>{contractData.contrato_contratada?.pj_nomefanta}</p>
                      </Col>

                      <Col md={3}>
                        <Label className="mt-4">
                          {isApostilamento
                            ? 'Valor adicionado'
                            : isAditamento
                              ? (Number(contractData.contrato_vlrGlobal) < 0 ? 'Valor suprimido' : 'Valor adicionado')
                              : 'Valor original'}
                        </Label>
                        <p style={{ fontWeight: 'bold' }}>{currencyFormatter.format(Math.abs(Number(contractData.contrato_vlrGlobal || 0)))}</p>
                      </Col>

                      {!isAditivoMode && (
                        <Col md={3}>
                          <Label className="mt-4">Valor total consolidado</Label>
                          <p style={{ fontWeight: 'bold' }}>{currencyFormatter.format(valorConsolidado)}</p>
                        </Col>
                      )}

                      {!isAditivoMode && (
                        <Col md={3}>
                          <Label className="mt-4">Data da proposta</Label>
                          <p style={{ fontWeight: 'bold' }}>{formatDateOrDash(contractData.contrato_dtProp)}</p>
                        </Col>
                      )}

                      <Col md={3}>
                        <Label className="mt-4">Data de assinatura</Label>
                        <p style={{ fontWeight: 'bold' }}>{formatDateOrDash(contractData.contrato_dtAssin)}</p>
                      </Col>

                      {(isAditivoMode || contractData.contrato_dtIniVig) && (
                        <Col md={3}>
                          <Label className="mt-4">Início de vigência</Label>
                          <p style={{ fontWeight: 'bold' }}>{formatDateOrDash(contractData.contrato_dtIniVig)}</p>
                        </Col>
                      )}

                      <Col md={3}>
                        <Label className="mt-4">{isAditivoMode ? 'Fim da vigência' : 'Fim da vigência (Original)'}</Label>
                        <p style={{ fontWeight: 'bold' }}>{formatDateOrDash(fimVigenciaOriginal)}</p>
                      </Col>

                      {!isAditivoMode && (
                        <Col md={3}>
                          <Label className="mt-4">Vigência Consolidada</Label>
                          <p style={{ fontWeight: 'bold' }}>{formatDateOrDash(vigenciaAtual)}</p>
                        </Col>
                      )}

                      {(isAditamento || (!isAditivoMode && contractData.contrato_prazoExecucao)) && (
                        <Col md={3}>
                          <Label className="mt-4">Prazo de execução</Label>
                          <p style={{ fontWeight: 'bold' }}>{formatDateOrDash(contractData.contrato_prazoExecucao)}</p>
                        </Col>
                      )}

                      {isAditamento && contractData.contratoAlterTp_desc && (
                        <Col md={3}>
                          <Label className="mt-4">Motivo</Label>
                          <p style={{ fontWeight: 'bold' }}>{contractData.contratoAlterTp_desc}</p>
                        </Col>
                      )}

                      {!hideAditivos && (
                        <Col md={12} className="mt-4">
                          <Label>Aditivos</Label>
                          {contractData.addendums && contractData.addendums.length > 0 ? (
                            <div className="table-responsive">
                              <table className="table table-bordered table-hover table-sm" style={{ width: '100%', fontSize: '13px' }}>
                                <thead className="thead-light">
                                  <tr>
                                    <th style={{ width: '12%' }}>Tipo</th>
                                    <th style={{ width: '12%' }}>Data Assinatura</th>
                                    <th style={{ width: '20%' }}>Motivo</th>
                                    <th style={{ width: '30%' }}>Objeto</th>
                                    <th style={{ width: '26%' }}>Alterações / Detalhes</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {contractData.addendums.map(a => {
                                    let tipoDesc = "Outro";
                                    let tipoCor = "secondary";
                                    switch (a.contratoInst_id) {
                                      case 1: tipoDesc = "Contrato";      tipoCor = "dark";    break;
                                      case 2: tipoDesc = "Aditamento";    tipoCor = "primary"; break;
                                      case 3: tipoDesc = "Apostilamento"; tipoCor = "info";    break;
                                      case 4: tipoDesc = "Renovação";     tipoCor = "success"; break;
                                      case 5: tipoDesc = "Rescisão";      tipoCor = "danger";  break;
                                    }

                                    let detalhes = [];
                                    if (a.contrato_vlrGlobal && Number(a.contrato_vlrGlobal) > 0) detalhes.push(`Valor adicionado: ${currencyFormatter.format(a.contrato_vlrGlobal)}`);
                                    if (a.contrato_dtIniVig) detalhes.push(`Início vigência: ${moment(a.contrato_dtIniVig).format('DD/MM/YYYY')}`);
                                    if (a.contrato_prazoVigencia) detalhes.push(`Fim vigência: ${moment(a.contrato_prazoVigencia).format('DD/MM/YYYY')}`);
                                    if (a.contrato_prazoExecucao) detalhes.push(`Fim execução: ${moment(a.contrato_prazoExecucao).format('DD/MM/YYYY')}`);
                                    if (a.contrato_fatorReaj != null) detalhes.push(`Fator reajuste: ${a.contrato_fatorReaj}% ${a.indReaj_sigla ? `(${a.indReaj_sigla})` : ''}`);

                                    return (
                                      <tr key={a.contrato_id}>
                                        <td className="align-middle">
                                          <span className={`badge badge-${tipoCor}`} style={{ padding: '5px 8px' }}>{tipoDesc}</span>
                                        </td>
                                        <td className="align-middle">{a.contrato_dtAssin ? moment(a.contrato_dtAssin).format('DD/MM/YYYY') : '-'}</td>
                                        <td className="align-middle">{a.contratoAlterTp_desc || '-'}</td>
                                        <td className="align-middle">{a.contrato_obj || '-'}</td>
                                        <td className="align-middle">
                                          {detalhes.length > 0 ? detalhes.map((d, i) => <div key={i}><strong>&bull;</strong> {d}</div>) : <span className="text-muted">-</span>}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <p style={{ fontWeight: 'bold', color: '#6c757d' }}>Nenhum aditivo registrado.</p>
                          )}
                        </Col>
                      )}

                      {!isAditivoMode && (
                        <>
                          <Col md={3}>
                            <Label className="mt-4">Permite renovação?</Label>
                            <p style={{ fontWeight: 'bold' }}>{contractData.contrato_permiteRenovacao === 1 ? 'Sim' : 'Não'}</p>
                          </Col>

                          <Col md={3}>
                            <Label className="mt-4">Aguardar OS?</Label>
                            <p style={{ fontWeight: 'bold' }}>{contractData.contrato_aguardarOS === 1 ? 'Sim' : 'Não'}</p>
                          </Col>

                          <Col md={3}>
                            <Label className="mt-4">Fiança</Label>
                            <p style={{ fontWeight: 'bold' }}>{contractData.contrato_fianca === 1 ? 'Sim' : 'Não'}</p>
                          </Col>

                          {contractData.contrato_fianca === 1 && (
                            <Col md={3}>
                              <Label className="mt-4">Data limite da fiança</Label>
                              <p style={{ fontWeight: 'bold' }}>{formatDateOrDash(contractData.contrato_dtLimFianca)}</p>
                            </Col>
                          )}
                        </>
                      )}

                      {(!isAditivoMode || isApostilamento) && (
                        <>
                          <Col md={3}>
                            <Label className="mt-4">Índice de reajuste</Label>
                            <p style={{ fontWeight: 'bold' }}>{contractData.contrato_indiceReaj || '-'}</p>
                          </Col>

                          {!isAditivoMode && (
                            <>
                              <Col md={3}>
                                <Label className="mt-4">Data de aniversário do reajuste</Label>
                                <p style={{ fontWeight: 'bold' }}>{formatDateOrDash(contractData.contrato_dtAnivReaj)}</p>
                              </Col>

                              <Col md={3}>
                                <Label className="mt-4">Data base do reajuste</Label>
                                <p style={{ fontWeight: 'bold' }}>{formatDateOrDash(contractData.contrato_dtBaseReaj)}</p>
                              </Col>

                              <Col md={3}>
                                <Label className="mt-4">Informações de pagamento</Label>
                                <p style={{ fontWeight: 'bold' }}>{contractData.contrato_infoPgto || '-'}</p>
                              </Col>
                            </>
                          )}
                        </>
                      )}

                      {isApostilamento && (
                        <>
                          <Col md={3}>
                            <Label className="mt-4">Fator de reajuste (%)</Label>
                            <p style={{ fontWeight: 'bold' }}>{contractData.contrato_fatorReaj}</p>
                          </Col>
                        </>
                      )}

                      <Col md={12}>
                        <Label className="mt-4">Observações</Label>
                        <p style={{ fontWeight: 'bold' }}>{contractData.contrato_obs}</p>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </TabPanel>

              {!hideCronograma && (
                <TabPanel>
                  {contractData.products?.length > 0 ? (
                    contractData.products.map(product => (
                      <Card key={product.contratoProd_id || product.contratoProd_desc}>
                        <CardBody>
                          <Row>
                            <Col md={6}>
                              <Label>Descrição</Label>
                              <p style={{ fontWeight: 'bold' }}>{product.contratoProd_desc || '-'}</p>
                            </Col>

                            <Col md={3}>
                              <Label>Prazo (dias)</Label>
                              <p style={{ fontWeight: 'bold' }}>{product.contratoProd_prazo ?? '-'}</p>
                            </Col>

                            {product.contratoProd_dtPrev && moment(product.contratoProd_dtPrev).isValid() && (
                              <Col md={3}>
                                <Label>Data de entrega prevista</Label>
                                <p style={{ fontWeight: 'bold' }}>{formatDateOrDash(product.contratoProd_dtPrev)}</p>
                              </Col>
                            )}
                          </Row>
                        </CardBody>
                      </Card>
                    ))
                  ) : (
                    <Card>
                      <CardBody>
                        <p className="text-muted mb-0">Nenhum produto cadastrado neste {isAditivoMode ? 'aditivo' : 'contrato'}.</p>
                      </CardBody>
                    </Card>
                  )}
                </TabPanel>
              )}

              {!hideCronograma && (
                <TabPanel>
                  {contractData.paymentEvents?.length > 0 ? (
                    contractData.paymentEvents.map(event => (
                      <Card key={event.contratoEP_id || `${event.contratoEP_desc}-${event.contratoEP_vlr}`}>
                        <CardBody>
                          <Row>
                            <Col>
                              <Label>Descrição</Label>
                              <p style={{ fontWeight: 'bold' }}>{event.contratoEP_desc || '-'}</p>
                            </Col>

                            <Col>
                              <Label>Tipo</Label>
                              <p style={{ fontWeight: 'bold' }}>{revenueTypes.find(t => t.value === event.recTp_id)?.label || '-'}</p>
                            </Col>

                            <Col>
                              <Label>Valor</Label>
                              <p style={{ fontWeight: 'bold' }}>{currencyFormatter.format(event.contratoEP_vlr)}</p>
                            </Col>

                            <Col>
                              <Label>Prazo (dias)</Label>
                              <p style={{ fontWeight: 'bold' }}>{event.contratoEP_prazo ?? '-'}</p>
                            </Col>

                            {event.contratoEP_dtPrev && moment(event.contratoEP_dtPrev).isValid() && (
                              <Col>
                                <Label>Data de pagamento prevista</Label>
                                <p style={{ fontWeight: 'bold' }}>{formatDateOrDash(event.contratoEP_dtPrev)}</p>
                              </Col>
                            )}
                          </Row>
                        </CardBody>
                      </Card>
                    ))
                  ) : (
                    <Card>
                      <CardBody>
                        <p className="text-muted mb-0">Nenhum evento de pagamento cadastrado neste {isAditivoMode ? 'aditivo' : 'contrato'}.</p>
                      </CardBody>
                    </Card>
                  )}
                </TabPanel>
              )}

              {!hideAditivos && (
                <TabPanel>
                  <div className='d-flex justify-content-between mb-3'>
                    <h4>Aditivos</h4>
                    <div className="d-flex flex-column align-items-end">
                      <AddContract2
                        preloading={() => this.props.getContract(this.props.match.params.id)}
                        buttonText="Cadastrar Aditivo"
                        isAditivoMode={true}
                        addContractDataDraft={{}}
                        data={{
                          products: [],
                          paymentEvents: [],
                          data: {
                            contrato_original: contractData.contrato_id,
                            vigencia_consolidada: vigenciaAtual,
                            prazoExecucao_consolidado: prazoExecucaoAtual,
                            contratoInst_id: 2,
                            pj_id: contractData.contrato_contratante?.pj_id || contractData.contrato_contratante,
                            proj_id: contractData.proj_id,
                            contrato_contratante: contractData.contrato_contratante?.pj_id || contractData.contrato_contratante,
                            contrato_contratada: contractData.contrato_contratada?.pj_id || contractData.contrato_contratada
                          }
                        }}
                      />
                      <Button
                        color="secondary"
                        className="mt-2"
                        onClick={this.handleSolicitarOrcamentoAditivo}
                        disabled={this.state.isCreatingAditivoNegociacao}
                      >
                        {this.state.isCreatingAditivoNegociacao ? <Spinner size="sm" /> : 'Solicitar orçamento aditivo'}
                      </Button>
                    </div>
                  </div>
                  {contractData.addendums?.length > 0 ? contractData.addendums.map(addendum => {
                    let tipoDesc = "Outro";
                    let tipoCor = "secondary";
                    switch (addendum.contratoInst_id) {
                      case 1: tipoDesc = "Contrato";      tipoCor = "dark";    break;
                      case 2: tipoDesc = "Aditamento";    tipoCor = "primary"; break;
                      case 3: tipoDesc = "Apostilamento"; tipoCor = "info";    break;
                      case 4: tipoDesc = "Renovação";     tipoCor = "success"; break;
                      case 5: tipoDesc = "Rescisão";      tipoCor = "danger";  break;
                    }
                    const isApostilamento = addendum.contratoInst_id === 3;
                    const isRescisao     = addendum.contratoInst_id === 5;
                    const isAditamento   = addendum.contratoInst_id === 2;

                    return (
                      <Card key={addendum.contrato_id} className="mb-3" style={{ border: '1px solid #e0e0e0', borderLeft: `4px solid var(--${tipoCor === 'dark' ? 'gray-800' : tipoCor})`, borderRadius: '6px' }}>
                        <CardBody>
                          {/* Cabeçalho: badge do tipo + botões */}
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <span className={`badge badge-${tipoCor}`} style={{ fontSize: '13px', padding: '6px 12px', borderRadius: '20px' }}>
                              {tipoDesc}
                            </span>
                            <div>
                              <Button size="sm" color="primary" className="mr-2" onClick={() => window.open(`https://oikos.ecoss.is/oikos-client/comercial/contratos/${addendum.contrato_id}`, '_blank')}>Acessar Aditivo</Button>
                              {addendum.arquivo_caminho && (
                                <Button size="sm" color="info" onClick={() => window.open(`https://oikos.ecoss.is/oikos/${addendum.arquivo_caminho}`, '_blank')}>Visualizar Documento</Button>
                              )}
                            </div>
                          </div>

                          <Row>
                            {/* Data de assinatura — sempre */}
                            <Col md={3}>
                              <Label className="text-muted" style={{ fontSize: '12px', marginBottom: '2px' }}>Data de assinatura</Label>
                              <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>{addendum.contrato_dtAssin ? moment(addendum.contrato_dtAssin).format('DD/MM/YYYY') : '-'}</p>
                            </Col>

                            {!isRescisao && (
                              <Col md={3}>
                                <Label className="text-muted" style={{ fontSize: '12px', marginBottom: '2px' }}>Início de vigência</Label>
                                <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>{addendum.contrato_dtIniVig ? moment(addendum.contrato_dtIniVig).format('DD/MM/YYYY') : '-'}</p>
                              </Col>
                            )}

                            {/* Vigência — exceto rescisão sem prazo */}
                            {!isRescisao && (
                              <Col md={3}>
                                <Label className="text-muted" style={{ fontSize: '12px', marginBottom: '2px' }}>Fim da vigência</Label>
                                <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>{addendum.contrato_prazoVigencia ? moment(addendum.contrato_prazoVigencia).format('DD/MM/YYYY') : '-'}</p>
                              </Col>
                            )}

                            {/* Prazo de execução — aditamento e renovação */}
                            {(isAditamento || addendum.contrato_prazoExecucao) && !isApostilamento && !isRescisao && (
                              <Col md={3}>
                                <Label className="text-muted" style={{ fontSize: '12px', marginBottom: '2px' }}>Prazo de execução</Label>
                                <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>{addendum.contrato_prazoExecucao ? moment(addendum.contrato_prazoExecucao).format('DD/MM/YYYY') : '-'}</p>
                              </Col>
                            )}

                            {/* Valor — aditamento e renovação */}
                            {!isApostilamento && !isRescisao && (
                              <Col md={3}>
                                <Label className="text-muted" style={{ fontSize: '12px', marginBottom: '2px' }}>Valor adicionado</Label>
                                <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>{currencyFormatter.format(addendum.contrato_vlrGlobal || 0)}</p>
                              </Col>
                            )}

                            {/* Campos específicos do Apostilamento */}
                            {isApostilamento && (
                              <>
                                {addendum.contrato_fatorReaj != null && (
                                  <Col md={3}>
                                    <Label className="text-muted" style={{ fontSize: '12px', marginBottom: '2px' }}>Fator de reajuste</Label>
                                    <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>{addendum.contrato_fatorReaj}%</p>
                                  </Col>
                                )}
                                {addendum.indReaj_sigla && (
                                  <Col md={3}>
                                    <Label className="text-muted" style={{ fontSize: '12px', marginBottom: '2px' }}>Índice de reajuste</Label>
                                    <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>{addendum.indReaj_sigla}</p>
                                  </Col>
                                )}
                                {addendum.contrato_dtBaseReaj && (
                                  <Col md={3}>
                                    <Label className="text-muted" style={{ fontSize: '12px', marginBottom: '2px' }}>Data base do reajuste</Label>
                                    <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>{moment(addendum.contrato_dtBaseReaj).format('DD/MM/YYYY')}</p>
                                  </Col>
                                )}
                              </>
                            )}

                            {/* Motivo da alteração — aditamento */}
                            {addendum.contratoAlterTp_desc && (
                              <Col md={3}>
                                <Label className="text-muted" style={{ fontSize: '12px', marginBottom: '2px' }}>Motivo</Label>
                                <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>{addendum.contratoAlterTp_desc}</p>
                              </Col>
                            )}

                            {/* Objeto — sempre, se houver */}
                            {addendum.contrato_obj && (
                              <Col md={12}>
                                <Label className="text-muted" style={{ fontSize: '12px', marginBottom: '2px' }}>Objeto</Label>
                                <p style={{ fontWeight: 'bold', marginBottom: '0' }}>{addendum.contrato_obj}</p>
                              </Col>
                            )}
                          </Row>
                        </CardBody>
                      </Card>
                    )
                  }) : (
                    <Card>
                      <CardBody>
                        <p className="text-muted text-center mb-0">Nenhum aditivo localizado associado a este contrato.</p>
                      </CardBody>
                    </Card>
                  )}
                </TabPanel>
              )}

              <TabPanel>
                <div className='d-flex justify-content-between'>
                  <Button
                    size="sm"
                    color="link"
                    className="mb-1 ml-1 px-0"
                    onClick={() => this.setState({ isFilesModalOpen: true })}
                  >
                    Adicionar novo
                  </Button>
                </div>
                {contractData.files?.map(file => (
                  <Card>
                    <CardBody>
                      <Row className="align-items-center justify-content-between">
                        <Col>
                          <Label>Descrição</Label>
                          <p style={{ fontWeight: 'bold' }}>
                            <a
                              href={`https://oikos.ecoss.is/oikos/${file?.arquivo_caminho}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {file.documento_desc}
                            </a>
                          </p>
                        </Col>
                        <Col>
                          <Label>Tipo</Label>
                          <p style={{ fontWeight: 'bold' }}>{file.tpDocumento_desc}</p>
                        </Col>
                        {this.props.auth.user.perm_id === 1 &&
                          <Button
                            title="Excluir"
                            className="mr-2"
                            color="light"
                            size="sm"
                            onClick={() => this.setState({ deleteModalOpen: true, arquivoData: file })}
                          >
                            <i className="ri-delete-bin-6-line" />
                          </Button>
                        }
                      </Row>
                    </CardBody>
                  </Card>
                ))}

              </TabPanel>
            </Tabs>
          </Container>
          <Modal
            size='lg'
            centered={false}
            isOpen={this.state.isFilesModalOpen}
            toggle={() => this.setState({ addEquiProjData: {}, isFilesModalOpen: false })}
          >
            <ModalHeader
              toggle={() => this.setState({
                addEquiProjData: {},
                isFilesModalOpen: false,
              })}
            >
              Adição de Documentos
            </ModalHeader>
            <ModalBody>
              <AddFiles
                drop={false}
                multiple={true}
                ref={this.filesRef}
                accept={['.pdf']}
              />
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                onClick={() => this.setState({ addEquiProjData: {}, isFilesModalOpen: false })}
                color="light"
                className="waves-effect"
              >
                Cancelar
              </Button>
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={() => {
                  this.handleSubmitFiles();
                }}
              >
                {!this.state.isUploading ? 'Adicionar' : <Spinner size={'sm'} />}
              </Button>
            </ModalFooter>
          </Modal>
          <Modal
            size='sm'
            centered
            isOpen={this.state.deleteModalOpen}
            toggle={() => this.setState({ deleteModalOpen: true })}
          >
            <ModalHeader>
              Confirmação de deleção
            </ModalHeader>
            <ModalBody>
              Confirma a deleção do documento <strong>{this.state.arquivoData.documento_desc}?</strong>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                onClick={() => this.setState({ deleteModalOpen: false })}
                color="light"
                className="waves-effect"
              >
                Cancelar
              </Button>
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={() => {
                  this.deleteDocuments(this.state.arquivoData.documento_id);
                }
                }

              >
                {!this.state.deleteIsLoading ? 'Deletar' : <Spinner size={'sm'} />}
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({
  comercial: state.comercial,
  types: state.types,
  auth: state.auth,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getContract,
  getLegalEntities,
  getRevenueTypes,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Contract)
